import { makeGetSelectors } from "@/utils/redux/selector";
import { NOTISTACK_STATE_KEY_LIST } from "@/redux/notistack/slice";

export const { getSnackbarList } = makeGetSelectors(
	"notistack",
	NOTISTACK_STATE_KEY_LIST,
);
